import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const FooterSection = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-4">
          {/* Logo & Description */}
          <div className="col-lg-3 col-md-6">
            <Link to="/" className="footer-logo-box">
              <img
                src="/Images/tour/muktinath-logo.png"
                alt="muktinath logo"
                className="footer-logo"
              />
            </Link>
            <p className="footer-desc">
              Plan your holy journey with <b>Muktinath Darshan</b>. 
              We specialize in Muktinath Yatra packages, Nepal pilgrimage tours, helicopter tours, and comfortable spiritual travel experiences.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Quick Links</h5>
            <div className="footer-line" />
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About </Link></li>
              {/* <li><Link to="/tour-packages">Tour Packages</Link></li> */}
              {/* <li><Link to="/activities">Activities</Link></li> */}
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>  

          {/* Popular Destinations */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Popular Destinations</h5>
            <div className="footer-line" />
            <ul className="footer-links two-column">
              <li><Link to="/">Kathmandu</Link></li>
              <li><Link to="/">Pokhara</Link></li>
              {/* <li><Link to="/port-blair">Port Blair</Link></li> */}
              <li><Link to="/">Manokamna</Link></li>
              <li><Link to="/">Lumbini</Link></li>
              <li><Link to="/">Muktinath</Link></li>
              {/* <li><Link to="/radhanagar-beach">Radhanagar Beach</Link></li> */}
              {/* <li><Link to="/elephant-beach">Elephant Beach</Link></li> */}
              <li><Link to="/">Chitwan</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Contact Us</h5>
            <div className="footer-line" />

            <div className="footer-contact">
              <div className="contact-footer-item">
                <div className="contact-icon address">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <p>Office Location</p>
                  <a
                    href="https://maps.app.goo.gl/hBdNok4XSiJjBRMQ8"
                    target="_blank"
                    rel="noreferrer"
                  >
                   Shop No. 1 Rapti Nagar Phase 4, Near Millenium City, Gorakhpur, Bihar - 273013
                  </a>
                </div>
              </div>

              <div className="contact-footer-item">
                <div className="contact-icon">
                  <FaPhoneAlt />
                </div>
                <div>
                  <p>Phone</p>
                  <a href="tel:+919919222273 ">+91-9919222273 </a>,<a href="tel:+918423730604 ">+91-8423730604 </a>
                </div>
              </div>

              <div className="contact-footer-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div>
                  <p>Email</p>
                  <a href="mailto:info@muktinathdarshan.com">
                    info@muktinathdarshan.com
                  </a>
                </div>
              </div>

              <div className="footer-socials">
                <a href="#"><FaFacebookF /></a>
                <a href="#"><FaTwitter /></a>
                <a href="#"><FaInstagram /></a>
                <a href="#"><FaYoutube /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
